import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { IconClose } from 'suomifi-icons';
import { baseStyles } from './InputClearButton.baseStyles.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../theme/SpacingProvider/SpacingProvider.js';
import '../../../reset/HtmlA/HtmlA.js';
import { HtmlButton } from '../../../reset/HtmlButton/HtmlButton.js';
import '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { VisuallyHidden } from '../../VisuallyHidden/VisuallyHidden.js';

var baseClassName = 'fi-input-clear-button';
var InputClearButtonClassNames = {
  icon: "".concat(baseClassName, "_icon")
};
var BaseInputClearButton = function (_super) {
  __extends(BaseInputClearButton, _super);
  function BaseInputClearButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BaseInputClearButton.prototype.render = function () {
    var _a = this.props,
      className = _a.className,
      label = _a.label;
      _a.theme;
      var onClick = _a.onClick,
      passProps = __rest(_a, ["className", "label", "theme", "onClick"]);
    return /*#__PURE__*/React.createElement(HtmlButton, __assign({}, passProps, {
      className: classnames(baseClassName, className),
      onClick: onClick
    }), /*#__PURE__*/React.createElement(VisuallyHidden, null, label), /*#__PURE__*/React.createElement(IconClose, {
      "aria-hidden": true,
      className: InputClearButtonClassNames.icon
    }));
  };
  return BaseInputClearButton;
}(Component);
var StyledInputClearButton = styled(BaseInputClearButton).withConfig({
  componentId: "sc-1df7mt5-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var InputClearButton = function InputClearButton(props) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(StyledInputClearButton, __assign({
      theme: suomifiTheme
    }, props));
  });
};
InputClearButton.displayName = 'InputClearButton';
var templateObject_1;

export { InputClearButton };
//# sourceMappingURL=InputClearButton.js.map
